import { useState, useEffect } from "react"
import { APP_URL } from "@forcepoint/platform-coreui"
import { NeoComponents, formatDate } from "@forcepoint/platform-utilityui"

const theme = NeoComponents.NeoTheme

export default function AlertsDropdown({ activeApp, userToken, setAlertsCount }) {
  const [alertOptions, setAlertOptions] = useState([])

  const fetchAlerts = () => {
    fetch(`${APP_URL}/api/alerts/active`, {
      method: "GET",
      headers: { Authorization: `Bearer ${userToken}` }
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.error) {
          setAlertOptions(res)
          setAlertsCount(res.length)
        }
      })
      .catch(() => console.log("Some error occurred"))
  }

  useEffect(() => {
    if (userToken && activeApp?.modules?.uiConfig?.enableNotifications) {
      fetchAlerts()
    }
  }, [activeApp])

  const dismiss = (id) => {
    fetch(`${APP_URL}/api/alerts/${id}/dismiss`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${userToken}` }
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.error) fetchAlerts()
      })
      .catch(() => console.log("Some error occurred"))
  }

  if (!alertOptions?.length) {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 16px",
        gap: 8
      }}>
        <NeoComponents.NeoIcon name="bell" size={28} fill={theme.neutral.cloudGray} />
        <NeoComponents.NeoText
          fs={13}
          color={theme.neutral.blueGray}
        >
          No notifications available.
        </NeoComponents.NeoText>
      </div>
    )
  }

  return (
    <>
      {alertOptions.map((alert, index) => (
        <div key={alert.id}>
          <div style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 10,
            padding: "12px 16px",
            boxSizing: "border-box",
            width: "100%"
          }}>
            {/* Icon circle */}
            <div style={{
              flexShrink: 0,
              width: 32,
              height: 32,
              borderRadius: "50%",
              background: theme.tagBackground.red,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: 1
            }}>
              <NeoComponents.NeoIcon
                name="outline_error"
                size={15}
                fill={theme.status.critical}
              />
            </div>

            {/* Message + timestamp */}
            <div style={{ flex: 1, minWidth: 0, overflowX: "hidden" }}>
              <div style={{
                fontSize: 13,
                fontWeight: theme.fontWeight.medium,
                color: theme.neutral.darkSlate,
                lineHeight: "1.5",
                wordBreak: "break-word",
                whiteSpace: "normal"
              }}>
                {alert.message}{alert.count > 1 ? ` (${alert.count})` : ""}
              </div>
              <div style={{
                fontSize: 11,
                color: theme.neutral.blueGray,
                marginTop: 4
              }}>
                {formatDate(alert.updatedAt, "DD MMM YYYY hh:mm:ss", "UTC")}
              </div>
            </div>

            {/* Dismiss button */}
            <div style={{ flexShrink: 0, marginTop: 6 }}>
              <NeoComponents.NeoIcon
                name="close"
                size={10}
                fill={theme.neutral.cloudGray}
                style={{ cursor: "pointer", display: "block" }}
                onClick={() => dismiss(alert.id)}
              />
            </div>
          </div>
          {index < alertOptions.length - 1 && <NeoComponents.NeoDivider />}
        </div>
      ))}
    </>
  )
}
